module.exports = __webpack_public_path__ + "img/71.df178dbe.svg";